import React, { PropsWithChildren } from 'react'
import ArchiveValueNarrativeModalProvider from './ArchiveValueNarrativeModalProvider'
import UnarchiveValueNarrativeModalProvider from './UnarchiveValueNarrativeModalProvider'
import DeleteValueNarrativeModalProvider from './DeleteValueNarrativeModalProvider'
import TransferValueNarrativeModalProvider from './TransferValueNarrativeModalProvider'

const ValueNarrativeActionsProvider = ({ children }: PropsWithChildren<{}>) => {
    return (
        <ArchiveValueNarrativeModalProvider>
            <UnarchiveValueNarrativeModalProvider>
                {/*<DeleteValueNarrativeModalProvider>*/}
                <TransferValueNarrativeModalProvider>{children}</TransferValueNarrativeModalProvider>
                {/*</DeleteValueNarrativeModalProvider>*/}
            </UnarchiveValueNarrativeModalProvider>
        </ArchiveValueNarrativeModalProvider>
    )
}

export default ValueNarrativeActionsProvider
